import React from "react";
import {
  Box,
  Typography,
  Container,
  useTheme,
  useMediaQuery,
  Grid2,
} from "@mui/material";
import AppConfig from "../../config";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid2
      container
      spacing={2}
      sx={{
        backgroundColor: AppConfig.colorPalette.primary.main,
        width: "100%",
        minHeight: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid2
        item
        size={{ xs: 12, sm: 8, md: 8, lg: 8 }}
        sx={{
          width: "100%",
          wordWrap: "break-word",
          height: "100%",
          display: "flex",
          alignItems: "center",
          paddingLeft: { xs: 0, sm: 3 },
          justifyContent: { xs: "center", sm: "flex-start" },
        }}
      >
        <Typography
          variant={isMobile ? "caption" : "body2"}
          color="text.primary"
          sx={{
            fontSize: {
              xs: "0.75rem",
              sm: "0.825rem",
              md: "0.875rem",
            },
            fontWeight: 500,
            color: AppConfig.colorPalette.secondary.light,
            wordBreak: "break-word",
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          {"Copyright \u00A9 "}
          {new Date().getFullYear()}
          {" Signpost. All rights reserved."}
        </Typography>
      </Grid2>
      <Grid2
        item
        size={{ xs: 12, sm: 4, md: 4, lg: 4 }}
        justifyItems={"flex-end"}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", sm: "flex-end" },
          paddingRight: { xs: 0, sm: 3 },
          paddingTop: { xs: 1, sm: 0 },
          paddingBottom: { xs: 1, sm: 0 },
        }}
      >
        <Typography
          variant={isMobile ? "caption" : "body2"}
          color="text.secondary"
          sx={{
            fontSize: {
              xs: "0.7rem",
              sm: "0.775rem",
              md: "0.825rem",
            },
            color: AppConfig.colorPalette.secondary.light,
            wordBreak: "break-word",
            textAlign: { xs: "center", sm: "right" },
          }}
        >
          Version 1.0.0
        </Typography>
      </Grid2>
    </Grid2>
  );
};

export default Footer;
